var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const defaultTimeoutMs = 2000;
class CommandMatcher {
    constructor(def) {
        this.internalMatches =
            def instanceof RegExp
                ? (command) => def.exec(command) !== null
                : (command) => def(command);
    }
    matches(command) {
        return this.internalMatches(command);
    }
}
class CommandSender {
    constructor(def) {
        this.internalSend =
            typeof def === 'string' ? (cred) => def : (cred) => def(cred);
    }
    send(cred) {
        return this.internalSend(cred);
    }
}
const initializationResultMessages = {
    authFailed: 'authentication failed',
    connectFailed: 'connection failed',
    connected: 'connected',
    verifyFailed: 'verification failed',
};
const initializerStepResults = ['fail', 'next', 'succeed'];
class InitializerStep {
    constructor(def) {
        this.def = def;
        this.sender = def.send ? new CommandSender(def.send) : undefined;
        this.succeed = def.succeed ? new CommandMatcher(def.succeed) : undefined;
        this.fail = def.fail ? new CommandMatcher(def.fail) : undefined;
        this.next = def.next ? new CommandMatcher(def.next) : undefined;
    }
    processCommand(command) {
        var _a, _b;
        let matched = false;
        for (const result of initializerStepResults) {
            matched = (_b = (_a = this[result]) === null || _a === void 0 ? void 0 : _a.matches(command)) !== null && _b !== void 0 ? _b : false;
            if (matched && this.onCommandMatched) {
                this.onCommandMatched(result);
                break;
            }
        }
    }
    run(socket, creds) {
        return __awaiter(this, void 0, void 0, function* () {
            let prevUnterminatedRegExp;
            let result = 'fail';
            if (this.def.unterminatedRegExp) {
                prevUnterminatedRegExp = socket.setUnterminatedRegExp(this.def.unterminatedRegExp);
            }
            try {
                yield this.send(socket, creds);
                result = yield this.waitForMatch();
            }
            finally {
                if (this.def.unterminatedRegExp) {
                    socket.setUnterminatedRegExp(prevUnterminatedRegExp);
                }
            }
            return result;
        });
    }
    send(socket, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sender === undefined)
                return;
            if (this.def.raw) {
                yield socket.sendRawAsync(this.sender.send(credentials !== null && credentials !== void 0 ? credentials : {}));
            }
            else {
                yield socket.sendAsync(this.sender.send(credentials !== null && credentials !== void 0 ? credentials : {}));
            }
        });
    }
    waitForMatch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.succeed && !this.fail && !this.next)
                return 'fail';
            return new Promise((resolve, reject) => {
                var _a;
                const timeout = window.setTimeout(() => {
                    this.onCommandMatched = undefined;
                    resolve('fail');
                }, (_a = this.def.timeoutMs) !== null && _a !== void 0 ? _a : defaultTimeoutMs);
                this.onCommandMatched = (result) => {
                    window.clearTimeout(timeout);
                    this.onCommandMatched = undefined;
                    resolve(result);
                };
            });
        });
    }
}
export class CommandSocketInitializer {
    constructor(socket, steps, credentials) {
        this.socket = socket;
        this.steps = steps;
        this.credentials = credentials;
        this.commands = [];
        // bind callbacks
        this.onCommand = this.onCommand.bind(this);
        this.log = socket.logFactory.channel('CommandSocketInitializer');
    }
    static initialize(socket, steps, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializer = new CommandSocketInitializer(socket, steps, credentials);
            return yield initializer.run();
        });
    }
    run() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let result = 'fail';
            this.asyncHandlerId = this.socket.registerAsync({
                match: (command) => command,
                callback: this.onCommand,
            });
            for (const step of this.steps) {
                this.currentStep = new InitializerStep(step);
                result = yield this.currentStep.run(this.socket, this.credentials);
                if (result !== 'next')
                    break;
            }
            if (this.asyncHandlerId !== undefined)
                this.socket.unregisterAsync(this.asyncHandlerId);
            if (result === 'fail') {
                const errorCode = (_b = (_a = this.currentStep) === null || _a === void 0 ? void 0 : _a.def.errorCode) !== null && _b !== void 0 ? _b : 'connectFailed';
                this.log.info(initializationResultMessages[errorCode]);
                return errorCode;
            }
            return 'connected';
        });
    }
    onCommand(newCommand) {
        this.commands.push(newCommand);
        if (this.currentStep === undefined)
            return;
        let command = this.commands.shift();
        while (command !== undefined) {
            this.currentStep.processCommand(command);
            if (this.currentStep === undefined)
                break;
            command = this.commands.shift();
        }
    }
}
